import { db } from './firebase';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';

// Save or update a campaign under a user
export const saveCampaign = async (uid, campaignId, data) => {
  const ref = doc(db, 'users', uid, 'campaigns', campaignId);
  await setDoc(ref, {
    ...data,
    updatedAt: serverTimestamp(),
    createdAt: data.createdAt || serverTimestamp(),
  }, { merge: true });
};

// Save or update a brief under a campaign for a user
export const saveBrief = async (uid, campaignId, briefId, data) => {
  const ref = doc(db, 'users', uid, 'campaigns', campaignId, 'briefs', briefId);
  await setDoc(ref, {
    ...data,
    updatedAt: serverTimestamp(),
    createdAt: data.createdAt || serverTimestamp(),
  }, { merge: true });
};

// Save or update a script under a brief for a user
export const saveScript = async (uid, campaignId, briefId, scriptId, data) => {
  const ref = doc(db, 'users', uid, 'campaigns', campaignId, 'briefs', briefId, 'scripts', scriptId);
  await setDoc(ref, {
    ...data,
    updatedAt: serverTimestamp(),
    createdAt: data.createdAt || serverTimestamp(),
  }, { merge: true });
}; 